(() => {

  const STORAGE_KEY =
    'peernest_admin_view';


  let profile = null;
  let initialized = false;


  function getMode() {

    const saved =
      window.localStorage
        .getItem(
          STORAGE_KEY
        );


    return saved === 'student'
      ? 'student'
      : 'admin';

  }


  function pageContext() {

    const path =
      window.location.pathname
        .toLowerCase();


    if (
      path.includes(
        'colleges'
      )
    ) {
      return 'Colleges';
    }


    if (
      path.includes(
        'mentors'
      )
    ) {
      return 'Mentors';
    }


    if (
      path.includes(
        'events'
      )
    ) {
      return 'Events';
    }


    if (
      path.includes(
        'communities'
      )
    ) {
      return 'Communities';
    }


    if (
      path.includes(
        'admin'
      )
    ) {
      return 'Control Room';
    }


    return 'PeerNest';
  }


  function updateSwitches(
    mode
  ) {

    document
      .querySelectorAll(
        '[data-pn-admin-view]'
      )
      .forEach(
        button => {

          button.classList.toggle(
            'is-active',
            button.dataset
              .pnAdminView === mode
          );

        }
      );

  }


  function applyMode(
    mode,
    persist = true
  ) {

    const finalMode =
      mode === 'student'
        ? 'student'
        : 'admin';


    if (persist) {

      window.localStorage
        .setItem(
          STORAGE_KEY,
          finalMode
        );

    }


    document.documentElement
      .dataset
      .pnAdminView =
        finalMode;


    const bar =
      document.querySelector(
        '[data-pn-admin-mode-bar]'
      );


    if (bar) {

      bar.hidden =
        finalMode !== 'admin';

    }


    updateSwitches(
      finalMode
    );


    document.dispatchEvent(
      new CustomEvent(
        'peernest:admin-view-changed',
        {
          detail:{
            mode:
              finalMode,

            profile
          }
        }
      )
    );

  }


  function createSwitch(
    panel
  ) {

    if (
      !panel ||
      panel.querySelector(
        '[data-pn-admin-view-switch]'
      )
    ) {
      return;
    }


    const switcher =
      document.createElement(
        'div'
      );


    switcher.className =
      'pn-admin-view-switch';


    switcher.dataset
      .pnAdminViewSwitch =
        '';


    switcher.innerHTML = `
      <button
        type="button"
        data-pn-admin-view="student"
      >
        Student View
      </button>

      <button
        type="button"
        data-pn-admin-view="admin"
      >
        Admin Mode
      </button>
    `;


    const dashboardLink =
      panel.querySelector(
        '[data-pnauth-dashboard-link]'
      );


    if (dashboardLink) {

      panel.insertBefore(
        switcher,
        dashboardLink
      );

    }

    else {

      panel.appendChild(
        switcher
      );

    }


    switcher
      .querySelectorAll(
        '[data-pn-admin-view]'
      )
      .forEach(
        button => {

          button.addEventListener(
            'click',
            () => {

              applyMode(
                button.dataset
                  .pnAdminView
              );

            }
          );

        }
      );

  }


  function installSwitches() {

    document
      .querySelectorAll(
        '.pn-profile-menu__panel, .pn-mobile-profile'
      )
      .forEach(
        createSwitch
      );

  }


  async function init() {

    if (initialized) {
      return;
    }


    if (!window.PeerNestDB) {
      return;
    }


    initialized = true;


    try {

      profile =
        await window.PeerNestDB
          .getMyProfile();


      const isAdmin =
        profile?.role === 'admin' &&
        profile?.account_status ===
          'active';


      if (!isAdmin) {

        document.documentElement
          .removeAttribute(
            'data-pn-admin-view'
          );

        return;
      }


      document.documentElement
        .dataset
        .pnIsAdmin =
          'true';


      installSwitches();


      const context =
        document.querySelector(
          '[data-pn-admin-context]'
        );


      if (context) {

        context.textContent =
          `Viewing: ${pageContext()}`;

      }


      document
        .querySelectorAll(
          '[data-pn-admin-mode-student]'
        )
        .forEach(
          button => {

            button.addEventListener(
              'click',
              () => {

                applyMode(
                  'student'
                );

              }
            );

          }
        );


      applyMode(
        getMode(),
        false
      );

    }

    catch (error) {

      console.error(
        '[PeerNest] Admin mode:',
        error
      );

    }

  }


  if (
    window.PeerNestDB
  ) {

    init();

  }

  else {

    document.addEventListener(
      'peernest:supabase-ready',
      init,
      {
        once:true
      }
    );

  }

})();
